import styled from "styled-components";

export const CustomHideScrollBar = styled.div`
    &::-webkit-scrollbar {
		display: none;
	}

	&::-webkit-scrollbar {
		height: 0px;
		background: transparent;
		position: absolute;
	}
`;